import { useLoaderData, useNavigate, useOutletContext } from "react-router-dom";
import { useState, useLayoutEffect } from "react";
import { arrayRemove, deleteDoc, doc, getFirestore, updateDoc } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { app } from "../../../functions/firebaseInit";
import DisplayCupBrowse from "../../track-components/DisplayCupBrowse";
import ChangeUsername from "../../ChangeUsername/ChangeUsername";
import Button from "../../Button/Button";
import { deleteUser, getAuth } from "firebase/auth";
import DeleteAccount from "../../pops/DeleteAccount/DeleteAccount";
import { EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
import FullScreenPop from "../../pops/FullScreenPop";
import trackToString from "../../../functions/trackToString";
import SmallPop from "../../pops/SmallPop";
import "../Browse/Browse.css"

export default function ProfileEdit() {
    const loader = useLoaderData();
    const navigate = useNavigate();
    const fbApp = initializeApp(app);
    const firestore = getFirestore(fbApp);
    const auth = getAuth(fbApp);

    const [width] = useOutletContext();

    const [displayName, setDisplayName] = useState(loader.displayName);
    const [showReauth, setShowReauth] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const trashIcon = require("../../../assets/icons/icons8-waste-50.png");
    const backArrow = require("../../../assets/icons/icons8-back-arrow-60.png");
    const [deleteCup, setDeleteCup] = useState(null);

    // navigate out if no access to page
    useLayoutEffect(() => {
        if (!loader?.displayName || loader?.id !== auth?.currentUser?.uid) {
            navigate(`/profile/${loader?.id}`, { replace: true });
        }
    }, [loader, navigate, auth]);

    const [smallPop, setSmallPop] = useState();
    useLayoutEffect(() => {
        const timeout = setTimeout(() => {
            setSmallPop(false);
        }, 3500);

        return () => clearTimeout(timeout);
    }, [smallPop]);

    const changeName = async () => {
        const userDoc = doc(firestore, "users", auth.currentUser.uid);
        await updateDoc(userDoc, {
            displayName: displayName,
            displayNameLower: displayName.toLowerCase()
        })
            .catch((e) => setSmallPop(e.message));
    }

    return <div id="main-container">
        <div id="content-container">
            <Button
                text="Return to profile"
                icon={backArrow}
                onClick={() => navigate(-1)}
            />
            
            <ChangeUsername
                displayName={loader.displayName}
                displayNameLower={loader.displayNameLower}
                changeName={setDisplayName}
                onSubmit={changeName}
                uid={auth.currentUser?.uid}
                showChangeButton={true}
            />

            <div id="pfp-user-cups">
                <h2>Delete a cup:</h2>
                <ul id="cup-list">
                    {
                        loader.cups?.length > 0 && loader.cups.map((element) => {
                            return <li key={element.id}>
                                <button className="delete-button" title="Delete Cup"
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        setDeleteCup(element);
                                    }}
                                >
                                    <img style={{ height: 35, width: 35 }} src={trashIcon} alt="Delete icon" />
                                </button>
                                <div className="trackContainer">
                                    <h5>{element.cupName}</h5>
                                    <DisplayCupBrowse
                                        tracks={element.tracks}
                                        width={width}
                                        page="browse"
                                    />
                                </div>
                            </li>
                        })
                    }
                </ul>
            </div>



            {
                // pop handles delete
                deleteCup && <FullScreenPop
                    header="⚠ Delete Cup"
                    closePop={() => setDeleteCup(null)}
                    component={<>
                        <p>Deleting a cup cannot be undone. Are you sure you want to delete this cup?</p>
                        <p>{deleteCup.cupName}</p>
                        <ol>
                            {
                                deleteCup.tracks.map((element, index) => {
                                    return <li key={index}>
                                        {trackToString(element)}
                                    </li>
                                })
                            }
                        </ol>
                        <Button
                            text="Delete Cup"
                            icon={trashIcon}
                            onClick={async () => {
                                const cupDoc = doc(firestore, "cups", deleteCup.id);
                                const userDoc = doc(firestore, "users", auth.currentUser.uid);

                                await updateDoc(userDoc, {
                                    cups: arrayRemove(cupDoc)
                                })
                                    .then(async () => {
                                        await deleteDoc(cupDoc)
                                            .then(() => {
                                                // console.log("deleted")
                                                setDeleteCup(null);
                                            });
                                    })
                                    .catch((e) => setSmallPop(e.message));
                                navigate(0, { replace: true });
                            }}
                        />
                    </>}
                />
            }

            {
                // pop handles deleting account
                showReauth && <DeleteAccount
                    errorMessage={errorMessage}
                    close={() => setShowReauth(false)}
                    delete={async (password) => {
                        setErrorMessage("");
                        const credential = EmailAuthProvider.credential(
                            auth.currentUser.email, password
                        );
                        await reauthenticateWithCredential(auth.currentUser, credential)
                            .then(async () => {
                                // console.log("deleting userdata", auth.currentUser.email);
                                if (loader.cups.length > 0) {
                                    // console.log("deleting cups")
                                    for (const cup in loader.cups) {
                                        const cupDoc = doc(firestore, "cups", loader.cups[cup].id);
                                        await deleteDoc(cupDoc);
                                        // console.log("deleted cup", cup);
                                    }
                                }
                                await deleteDoc(doc(firestore, "users", auth.currentUser.uid))
                                    .then(async () => {
                                        //console.log("doc deleted");
                                        await deleteUser(auth.currentUser)
                                            .then(() => {
                                                // console.log("user deleted");
                                                navigate("/cup-builder", { replace: true, state: { deletingAccount: true } });
                                            })
                                    })

                            }).catch((e) => {
                                setErrorMessage(e.message);
                                console.log(e.message);
                            });
                    }}
                />
            }

            <Button
                text="Delete Account"
                icon={trashIcon}
                onClick={(e) => {
                    e.preventDefault();
                    setShowReauth(true);
                }}
            />

            {
                !!smallPop && <SmallPop text={smallPop} />
            }
        </div>
    </div>
}